import { NgModule } from '@angular/core';
import { CompletedComponent } from './completed.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
    TranslateLoader,
    TranslateModule,
    TranslateService
} from '@ngx-translate/core';
import { BootstrapModalModule } from 'ngx-modialog/plugins/bootstrap';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule } from '@angular/common/http';
import { HttpModule } from '@angular/http';
import { ResponsiveModule } from 'ng2-responsive';
import { NgxMaskModule } from 'ngx-mask';
import { CommonModule } from '@angular/common';
import { Angular2SocialLoginModule } from 'angular2-social-login';
import { ModalModule } from 'ngx-modialog';
import { ToastrModule } from 'ngx-toastr';
import { CustomFormsModule } from 'ng2-validation';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppRoutingModule } from '../app-routing.module';
import { OverlayModule } from 'angular-io-overlay/src/overlay';
import { LoaderModule } from '../shared/components/loader/loader.module';
import { ThumbSourceFactoryService } from '../shared/services/thumb-source-factory.service';
import { GoogleAnalyticsService } from '../shared/services/google-analytics.service';
import { EbitService } from '../shared/services/ebit.service';
import { StoreConfigurationsService } from '../shared/services/store-configurations.service';
import { CompletedSubscriptionComponent } from './subscription/completed.subscription.component';
import { CompletedPaymentMethodComponent } from './payment-method/completed.payment-method.component';
import { FacebookService } from '../shared/services/facebook.service';
import { CompletedEbitBannerComponent } from './ebit-banner/completed.ebit-banner.component';
import { GoogleConversionTagModule } from '../shared/components/google-conversion-tag/google-conversion-tag.module';
import { GoogleEcommerceTransactionModule } from '../shared/components/google-ecommerce-transaction/google-ecommerce-transaction.module';
import { CompletedResumeComponent } from './resume/completed.resume.component';
import { CompletedTitleComponent } from './title/completed.title.component';
import { CompletedOrderComponent } from './order/completed.order.component';
import { CompletedOrderItemsComponent } from './order/items/completed.order.items.component';
import { CompletedDeliveryAddressComponent } from './delivery-address/completed.delivery-address.component';
import { WebpackTranslateLoader } from '../webpack-translate-loader';
import { GoogleAdwordsConversionModule } from '../shared/components/google-adwords-conversion/google-adwords-conversion.module';
import { GoogleCustomerReviewsModule } from '../shared/components/google-customer-reviews/google-customer-reviews.module';
import { GoogleGtagService } from '../shared/services/google.gtag.service';
import { DataLayerModule } from '../shared/data-layer/data-layer.module';
import { BuzzleadModule } from '../shared/components/buzzlead/buzzlead.module';
import { ClipboardModule } from 'ngx-clipboard/dist';
import { TranslationConfiguratorService } from '../shared/services/translation-configurator.service';
import { LocaleProvider } from '../shared/services/locale.service';
import { Ng2DeviceDetectorModule } from 'ng2-device-detector';
import { CompletedOrderItemsAttributesExtraFieldsComponent } from './order/items/attributes-extra-fields/completed.order.items.attributes-extra-fields.component';
import { CompletedOrderItemsExtraFieldsComponent } from './order/items/extra-fields/completed.order.items.extra-fields.component';
import { GooglePatternNumberFormatter } from '../shared/services/google-pattern-number-formatter';
import { CompletedPaymentMethodPixComponent } from './payment-method/pix/completed.payment-method.pix.component';
import { CompletedPaymentMethodBankSlipComponent } from './payment-method/bank-slip/completed.payment-method.bank-slip.component';
import { AppsService } from '../shared/services/apps.service';

@NgModule({
    declarations: [
        CompletedComponent,
        CompletedSubscriptionComponent,
        CompletedOrderComponent,
        CompletedOrderItemsComponent,
        CompletedOrderItemsExtraFieldsComponent,
        CompletedOrderItemsAttributesExtraFieldsComponent,
        CompletedPaymentMethodComponent,
        CompletedPaymentMethodPixComponent,
        CompletedPaymentMethodBankSlipComponent,
        CompletedResumeComponent,
        CompletedTitleComponent,
        CompletedEbitBannerComponent,
        CompletedDeliveryAddressComponent
    ],
    imports: [
        LoaderModule,
        BrowserModule,
        CommonModule,
        HttpModule,
        HttpClientModule,
        FormsModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useClass: WebpackTranslateLoader
            }
        }),
        Angular2SocialLoginModule,
        FormsModule,
        ReactiveFormsModule,
        NgxMaskModule,
        AppRoutingModule,
        OverlayModule,
        CustomFormsModule,
        // DatePickerModule
        ResponsiveModule,
        ModalModule.forRoot(),
        BootstrapModalModule,
        BrowserAnimationsModule,
        ToastrModule.forRoot({
            timeOut: 10000,
            positionClass: 'toast-top-full-width',
            preventDuplicates: true
        }),
        GoogleConversionTagModule,
        GoogleEcommerceTransactionModule,
        GoogleAdwordsConversionModule,
        GoogleCustomerReviewsModule,
        BuzzleadModule,
        DataLayerModule,
        ClipboardModule,
        Ng2DeviceDetectorModule.forRoot()
    ],
    providers: [
        ThumbSourceFactoryService,
        GoogleAnalyticsService,
        GoogleGtagService,
        EbitService,
        FacebookService,
        StoreConfigurationsService,
        AppsService,
        LocaleProvider,
        GooglePatternNumberFormatter
    ]
})
export class CompletedModule {

    constructor(
        public translate: TranslateService
    ) {
        translate.use(
            TranslationConfiguratorService.decideUseLanguage(this.translate.getBrowserLang())
        );
    }

}



// WEBPACK FOOTER //
// /codebuild/output/src3659550778/src/src/app/completed/completed.module.ts